import { render } from "./TableBucketBillHistory.vue?vue&type=template&id=09a0cbe6&scoped=true"
import script from "./TableBucketBillHistory.vue?vue&type=script&lang=js"
export * from "./TableBucketBillHistory.vue?vue&type=script&lang=js"

import "./TableBucketBillHistory.vue?vue&type=style&index=0&id=09a0cbe6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Gerente de TI\\Downloads\\temp\\JB\\new-project\\jb-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09a0cbe6"]])

export default __exports__